// extracted by mini-css-extract-plugin
module.exports = {"marker":"MapMarker-module--marker--2hpSn"};